export const GET_HOME_ITEMS_SUCCESS = 'GET_HOME_ITEMS_SUCCESS';
export const GET_HOME_ITEMS_FAILURE = 'GET_HOME_ITEMS_FAILURE';
export const GET_CATEGORY_ITEMS_SUCCESS = 'GET_CATEGORY_ITEMS_SUCCESS';
export const GET_CATEGORY_ITEMS_FAILURE = 'GET_CATEGORY_ITEMS_FAILURE';
export const GET_TOURS_SUCCESS = 'GET_TOURS_SUCCESS';
export const GET_TOURS_FAILURE = 'GET_TOURS_FAILURE';
export const GET_CARS_SUCCESS = 'GET_CARS_SUCCESS';
export const GET_CARS_FAILURE = 'GET_CARS_FAILURE';
export const BOOKING_HOTEL_ROOM = 'BOOKING_HOTEL_ROOM';
export const BOOKING = 'BOOKING';
export const GET_CLIENT_BOOKINGS = 'GET_CLIENT_BOOKINGS';
export const GET_MY_PROFORMA_FAILURE = 'GET_MY_PROFORMA_FAILURE';
export const GET_MY_PROFORMA_SUCCESS = 'GET_MY_PROFORMA_SUCCESS';
export const REQUEST_PROFORMA_FAILURE = 'REQUEST_PROFORMA_FAILURE';
export const REQUEST_PROFORMA_SUCCESS = 'REQUEST_PROFORMA_SUCCESS';
export const GET_SINGLE_PROFORMA_SUCCESS = 'GET_SINGLE_PROFORMA_SUCCESS';
export const GET_SINGLE_PROFORMA_FAILURE = 'GET_SINGLE_PROFORMA_FAILURE';
export const SEARCH_SUCCESS = 'SEARCH_SUCCESS';
export const SEARCH_FAILURE = 'SEARCH_FAILURE';
export const GET_CLIENT_BOOKINGS_FAILURE = 'GET_CLIENT_BOOKINGS_FAILURE';
export const RESET_REQUEST_STATUS = 'RESET_REQUEST_STATUS';
